
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798F8F","stroke-linecap":"round","stroke-linejoin":"round","d":"M14.51 12.415c0 .3-.124.59-.346.802a1.2 1.2 0 0 1-.838.333l-9.638-.005c-.315 0-.616-.12-.838-.332a1.1 1.1 0 0 1-.347-.802V4.646c0-.3.125-.59.347-.802s.523-.332.838-.332h2.996l1.403 1.994h5.237c.314 0 .615.12.838.332s.346.502.346.803z"}})])
          )
        }
      }
    